import { screen } from 'components/styles/variables';

export interface StickyHeaderContainerProps {
  isShowing: boolean;
  children: JSX.Element;
}

export default function StickyHeaderContainer({
  isShowing,
  children,
}: StickyHeaderContainerProps): JSX.Element {
  return (
    <div className="sticky-header-container">
      {isShowing && children}
      <style jsx>{`
        .sticky-header-container {
          display: none;
        }

        @media (min-width: ${screen.smMin}) {
          .sticky-header-container {
            display: block;
          }
        }
      `}</style>
    </div>
  );
}
